import Button from '../../../../components/Button';
import { codes } from '../../../../data/translations';
import { useTranslationAPI } from '../../../translations';
import { ModGossip } from '../../../../components/Icons/ModGossip';
import { IconButton } from '../../../../components/IconButton';
import { FC } from 'react';

type DetailPagePlaceholderCommentsButtonProps = {
	isShortInfo?: boolean;
};

const DetailPagePlaceholderCommentsButton: FC<DetailPagePlaceholderCommentsButtonProps> = ({ isShortInfo }) => {
	const { translate } = useTranslationAPI();

	return (
		<div
			style={{
				height: '40px',
				position: 'relative',
			}}
			data-testid='commentsButton'
		>
			{isShortInfo && (
				<IconButton
					rounded
					dataFunction='commentsButton'
					disabled
				>
					<ModGossip
						style={{
							color: 'var(--oc-green-7)',
						}}
					/>
				</IconButton>
			)}
			{!isShortInfo && (
				<Button
					startIcon={
						<ModGossip
							style={{
								color: 'var(--oc-green-7)',
							}}
						/>
					}
					rounded
					dataFunction='commentsButton'
					disabled
				>
					{translate(codes.comments)}
				</Button>
			)}
		</div>
	);
};

export { DetailPagePlaceholderCommentsButton };
